(() => {
  const models = ['upstart', 'model-t', '2wenty'];
  const googleUrl = (raw, embedded) => {
    if (!raw) return '';
    try {
      const url = new URL(raw);
      if (url.protocol !== 'https:') return '';
      if (embedded) return url.hostname === 'calendar.google.com' && /^\/calendar\/(?:u\/\d+\/)?appointments\/schedules\//.test(url.pathname) ? url.href : '';
      return ['calendar.google.com', 'calendar.app.google'].includes(url.hostname) ? url.href : '';
    } catch (_) { return ''; }
  };
  const nativeAppUrl = (raw, model) => {
    try {
      const url = new URL(raw);
      if (url.protocol !== 'https:' || url.hostname !== 'script.google.com' || url.port || url.username || url.password ||
          !/^\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(url.pathname)) return '';
      url.search = ''; url.hash = '';
      url.searchParams.set('model', models.includes(model) ? model : 'upstart');
      // Carry only campaign labels for this booking. No contact details, fbclid or persistent storage.
      const context = new URLSearchParams(window.location.search);
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(key => {
        const value=context.get(key);
        if(value && /^[^\u0000-\u001f\u007f<>@]{1,160}$/u.test(value))url.searchParams.set(key,value);
      });
      return url.href;
    } catch (_) { return ''; }
  };
  const trustedNativeOrigin = (origin) => {
    try {
      const url = new URL(origin);
      return url.protocol === 'https:' && !url.port && !url.username && !url.password && (
        url.hostname === 'script.google.com' || url.hostname === 'script.googleusercontent.com' ||
        /^[a-z0-9-]+(?:\.script|-script)\.googleusercontent\.com$/.test(url.hostname)
      );
    } catch (_) { return false; }
  };
  const sourceBelongsToFrame = (source, frame) => {
    // Apps Script runs customer HTML in a nested Google sandbox. Cross-origin
    // WindowProxy.parent is readable; do not inspect any frame DOM or URL.
    try {
      let current = source;
      for (let depth = 0; current && depth < 5; depth++) {
        if (current === frame.contentWindow) return true;
        const parent = current.parent;
        if (!parent || parent === current) return false;
        current = parent;
      }
    } catch (_) {}
    return false;
  };
  const initNative = (root) => {
    if (root.dataset.nativeBookingReady) return;
    const wrap = root.querySelector('[data-native-booking-frame-wrap]');
    const status = root.querySelector('[data-native-booking-status]');
    const external = root.querySelector('[data-native-booking-external]');
    const fallback = root.querySelector('[data-native-booking-fallback]');
    const progress = root.querySelector('[data-native-booking-progress]');
    if (!wrap || !status || !external || !fallback || !progress) return;
    root.dataset.nativeBookingReady = 'true';
    root.dataset.nativeBookingState = 'loading';
    fallback.hidden = false;
    progress.hidden = false;
    const model = new URLSearchParams(window.location.search).get('model');
    const src = nativeAppUrl(root.dataset.nativeAppUrl, model);
    if (!src) {
      root.dataset.nativeBookingState = 'fallback';
      progress.hidden = true;
      wrap.removeAttribute('aria-busy');
      status.textContent = 'Le formulaire est momentanément indisponible. Appelez-nous au 01 85 09 21 41 pour réserver.';
      external.removeAttribute('href');
      external.hidden = true;
      return;
    }
    external.href = src;
    external.removeAttribute('aria-disabled');
    const frame = document.createElement('iframe');
    frame.title = 'Réserver un essai gratuit Momentum Electric — modèle, date et heure';
    frame.loading = 'eager';
    // Reveal only the public origin so Firefox ancestorOrigins can verify Momentum.
    // Never forward page paths, query parameters or contact details.
    frame.referrerPolicy = 'strict-origin';
    frame.setAttribute('scrolling', 'auto');
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    // Do not set a second sandbox: Apps Script already supplies its own.
    let timeout;
    let active = true;
    const showFallback = (message) => {
      if (!active) return;
      window.clearTimeout(timeout);
      wrap.removeAttribute('aria-busy');
      root.dataset.nativeBookingState = 'fallback';
      fallback.hidden = false;
      progress.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      status.textContent = message;
    };
    // An iframe load also fires for blocked Google sign-in/redirect pages. Only
    // the actual form's authenticated height message proves that it rendered.
    frame.addEventListener('error', () => {
      showFallback('Le formulaire ne s’est pas ouvert ici. Choisissez votre créneau dans un nouvel onglet.');
    }, {once: true});
    // Only a child of this booking iframe can request its host's cookie decision.
    let consentRecipient=null;
    const consentSnapshot=()=>{
      const saved=window.MomentumConsentState;
      const known=!!saved&&typeof saved.marketing==='boolean'&&typeof saved.updatedAt==='string'&&Number.isFinite(Date.parse(saved.updatedAt));
      const privacy=window.Shopify&&window.Shopify.customerPrivacy;
      let allowed=false;
      try{allowed=known&&saved.marketing===true&&!!privacy&&typeof privacy.marketingAllowed==='function'&&privacy.marketingAllowed()===true;}catch(_){}
      return {known,allowed};
    };
    const sendConsent=()=>{
      if(!active||!consentRecipient)return;
      const {source,origin,requestId}=consentRecipient;
      try{source.postMessage({type:'momentum-booking-consent',requestId,...consentSnapshot()},origin);}catch(_){}
    };
    const consentMessage=(event)=>{
      if(!active||!event||!trustedNativeOrigin(event.origin)||!sourceBelongsToFrame(event.source,frame)||!event.data||
        typeof event.data.requestId!=='string'||! /^[a-f0-9]{64}$/.test(event.data.requestId))return;
      if(event.data.type==='momentum-booking-consent-request'){
        consentRecipient={source:event.source,origin:event.origin,requestId:event.data.requestId};sendConsent();
      }else if(event.data.type==='momentum-booking-consent-manage'&&consentRecipient&&
        event.source===consentRecipient.source&&event.data.requestId===consentRecipient.requestId){
        if(window.MomentumCookieConsent&&typeof window.MomentumCookieConsent.open==='function')window.MomentumCookieConsent.open(true);
      }
    };
    window.addEventListener('message',consentMessage);
    window.addEventListener('momentum:consent:update',sendConsent);
    document.addEventListener('visitorConsentCollected',sendConsent);
    if(window.Shopify&&typeof window.Shopify.loadFeatures==='function'){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],()=>sendConsent());
    }
    const resize = (event) => {
      if (!active || !event || !trustedNativeOrigin(event.origin) || !sourceBelongsToFrame(event.source, frame) ||
          !event.data || event.data.type !== 'momentum-native-booking-height' ||
          typeof event.data.height !== 'number' || !Number.isFinite(event.data.height)) return;
      const height = Math.max(680, Math.min(1600, Math.ceil(event.data.height)));
      window.clearTimeout(timeout);
      frame.style.height = height + 'px';
      frame.style.minHeight = '0';
      wrap.style.minHeight = '0';
      wrap.removeAttribute('aria-busy');
      root.dataset.nativeBookingState = 'ready';
      fallback.hidden = true;
      progress.hidden = true;
      frame.removeAttribute('aria-hidden');
      frame.tabIndex = 0;
    };
    window.addEventListener('message', resize);
    root.addEventListener('momentum-native-booking:destroy', () => {
      active = false;
      window.clearTimeout(timeout); window.removeEventListener('message', resize);
      window.removeEventListener('message',consentMessage);window.removeEventListener('momentum:consent:update',sendConsent);document.removeEventListener('visitorConsentCollected',sendConsent);consentRecipient=null;
    }, {once: true});
    timeout = window.setTimeout(() => {
      showFallback('Le formulaire met du temps à s’ouvrir ici. Retrouvez les mêmes créneaux dans un nouvel onglet.');
    }, 12000);
    frame.src = src;
    wrap.append(frame);
  };
  const init = (root) => {
    if (root.dataset.bookingReady) return;
    let config;
    try { config = JSON.parse(root.querySelector('[data-booking-config]').textContent); } catch (_) { return; }
    const select = root.querySelector('[data-booking-model]');
    const button = root.querySelector('[data-booking-open]');
    const panel = root.querySelector('[data-booking-panel]');
    const wrap = root.querySelector('[data-booking-frame-wrap]');
    const placeholder = root.querySelector('[data-booking-placeholder]');
    const status = root.querySelector('[data-booking-status]');
    const fallback = root.querySelector('[data-booking-fallback]');
    const retry = root.querySelector('[data-booking-retry]');
    const progress = root.querySelector('[data-booking-progress]');
    if (!select || !button || !panel || !wrap || !placeholder || !status || !fallback || !retry || !progress) return;
    root.dataset.bookingReady = 'true';
    let timeout;
    let sequence = 0;
    let activeFrame = null;
    const clearFrame = () => {
      sequence += 1;
      window.clearTimeout(timeout);
      activeFrame = null;
      wrap.replaceChildren();
      wrap.hidden = true;
      wrap.removeAttribute('aria-busy');
      progress.hidden = true;
      retry.hidden = true;
      retry.disabled = false;
      button.disabled = false;
    };
    const update = (writeUrl) => {
      const key = models.includes(select.value) ? select.value : 'upstart';
      const model = config[key];
      select.value = key;
      clearFrame();
      placeholder.hidden = false;
      root.querySelector('[data-booking-name]').textContent = model.name;
      root.querySelector('[data-booking-description]').textContent = model.description;
      const image = root.querySelector('[data-booking-image]');
      image.src = model.image;
      image.alt = 'Vélo électrique ' + model.name;
      const external = googleUrl(model.url, false);
      fallback.hidden = !external;
      if (external) fallback.href = external;
      else fallback.removeAttribute('href');
      fallback.setAttribute('aria-label', 'Ouvrir le calendrier ' + model.name + ' dans un nouvel onglet');
      status.textContent = 'Affichez les créneaux disponibles pour le ' + model.name + '.';
      if (writeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('model', key);
        try { window.history.replaceState(window.history.state, '', url.href); } catch (_) {}
      }
    };
    const initial = new URLSearchParams(window.location.search).get('model');
    select.value = models.includes(initial) ? initial : 'upstart';
    update(false);
    select.addEventListener('change', () => update(true));
    const openCalendar = (reload) => {
      if (activeFrame && !reload) {
        // The main button returns to the current calendar without losing an
        // appointment or contact details already being entered inside Google.
        panel.scrollIntoView({behavior: 'auto', block: 'start'});
        activeFrame.focus();
        return;
      }
      const model = config[select.value];
      const src = googleUrl(model.embed, true);
      if (!src) {
        status.textContent = 'Pour choisir votre créneau, ouvrez le calendrier ci-dessous.';
        if (!fallback.hidden) fallback.focus();
        return;
      }
      clearFrame();
      const request = sequence;
      placeholder.hidden = true;
      wrap.hidden = false;
      wrap.setAttribute('aria-busy', 'true');
      progress.hidden = false;
      retry.hidden = false;
      retry.disabled = true;
      button.disabled = true;
      status.textContent = 'Ouverture du calendrier ' + model.name + '…';
      const frame = document.createElement('iframe');
      frame.title = 'Réserver un essai gratuit du ' + model.name + ' — créneaux Google Agenda';
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.loading = 'eager';
      activeFrame = frame;
      const isCurrent = () => request === sequence && activeFrame === frame;
      const finishLoading = (message) => {
        if (!isCurrent()) return;
        window.clearTimeout(timeout);
        wrap.removeAttribute('aria-busy');
        progress.hidden = true;
        button.disabled = false;
        retry.disabled = false;
        status.textContent = message;
      };
      frame.addEventListener('load', () => {
        // A cross-origin iframe load does not prove that Google's availability
        // interface rendered. Keep both recovery actions accessible afterwards.
        finishLoading('Choisissez votre horaire ci-dessous. Si rien ne s’affiche, ouvrez le calendrier dans un nouvel onglet.');
      }, {once: true});
      frame.addEventListener('error', () => {
        finishLoading('Le calendrier ne s’est pas ouvert. Réessayez ou ouvrez-le dans un nouvel onglet.');
      }, {once: true});
      timeout = window.setTimeout(() => {
        finishLoading('Le calendrier met du temps à s’ouvrir. Vous pouvez réessayer ou l’ouvrir dans un nouvel onglet.');
      }, 8000);
      frame.src = src;
      wrap.append(frame);
      if (window.matchMedia('(max-width: 720px)').matches) {
        panel.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      }
    };
    button.addEventListener('click', () => openCalendar(false));
    retry.addEventListener('click', () => openCalendar(true));
  };
  document.querySelectorAll('[data-momentum-booking]').forEach(init);
  document.querySelectorAll('[data-momentum-native-booking]').forEach(initNative);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-momentum-booking]').forEach(init));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-momentum-native-booking]').forEach(initNative));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-momentum-native-booking]').forEach(root => root.dispatchEvent(new Event('momentum-native-booking:destroy')));
  });
})();
